import { ENDPOINT_QUOTES_DRAFT, ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

/**
 * Post draft to create draft
 * @param {object} draft || null
 * @param {string} reference || null
 * @param {string} worksiteCode || null
 */
const postDraft = ({ draft, reference, worksiteCode }) => {
  const worksiteCodeParam = worksiteCode ?? null;
  const params = draft
    ? {
        ...draft,
        reference,
        worksite_code: worksiteCodeParam,
      }
    : {
        reference,
        worksite_code: worksiteCodeParam,
      };

  return axiosAuth
    .post(
      `${ENDPOINT_ROOT}/${ENDPOINT_QUOTES_DRAFT}${
        params.id ? `/${params.id}` : ''
      }`,
      params,
    )
    .then((res) => res.data);
};
export default postDraft;
